import RoundClose from 'components/close/RoundClose'
import React, { PropsWithChildren, useState } from 'react'
import { HeaderType, iHeader } from './headerContextType'

const defaultHeaderContext = {
  title: 'Home',
  showBackButton: false,
  showHeader: false,
  rightIcon: <RoundClose label={'CLOSE'} />,
  searchResult: null,
  searchPlaceholder: 'Search shops, names...',
}

export const HeaderContext = React.createContext<HeaderType | null>(null)

const HeaderProvider: React.FC<PropsWithChildren<object>> = ({ children }) => {
  const [header, setHeader] = useState<iHeader>(defaultHeaderContext)
  const updateHeader = (header: iHeader) => {
    setHeader((prev) => ({ ...prev, ...header }))
  }
  const resetHeader = () => {
    setHeader(defaultHeaderContext)
  }
  const hideSearch = () => {
    setHeader((prev) => ({ ...prev, showSearch: false }))
  }
  return (
    <HeaderContext.Provider value={{ header, updateHeader, resetHeader, hideSearch }}>
      {children}
    </HeaderContext.Provider>
  )
}
export default HeaderProvider
